module.exports = __webpack_public_path__ + "static/media/telegram-channel.c71fefcb.png";